import api from '../index'

/**
 * 认证管理模块接口
 */

// 登录参数类型
interface LoginParams {
  account: string
  password: string
}

// 修改密码参数类型
interface PasswordEditParams {
  oldPassword: string
  password: string
}

// 发送验证码参数类型
interface SendVerifyCodeParams {
  phone: string
  type?: string
}

// 重置密码参数类型
interface ResetPasswordParams {
  phone: string
  password: string
  verifyCode: number
}

export default {
  // 登录
  login: (data: LoginParams) => {
    return api.post('/auth/login', data)
  },

  // 获取权限
  getPermission: () => {
    return api.get('/auth/getPermission')
  },

  // 获取用户信息
  getUserInfo: () => {
    return api.get('/auth/getUserInfo')
  },

  // 修改密码
  changePassword: (data: PasswordEditParams) => {
    return api.post('/auth/changePassword', data)
  },

  // 发送验证码
  sendVerifyCode: (data: SendVerifyCodeParams) => {
    return api.post('/auth/sendVerifyCode', data)
  },

  // 重置密码
  resetPassword: (data: ResetPasswordParams) => {
    return api.post('/auth/resetPassword', data)
  },
}
